import React,{useState, useEffect} from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import {getAuth, signOut} from 'firebase/auth';



function ProtectedRoutes() {

     const [loggedIn, setLoggedIn] =  useState();
     const auth = getAuth();
     const user = auth.currentUser;
     const loggedInLocalStorage = window.localStorage.getItem('loggedIn');

     return loggedInLocalStorage ? <Outlet /> : <Navigate to = "/app/" />

}

export default ProtectedRoutes
